<template>
  <b-modal :visible="visible" centered hide-header hide-footer ok-disabled cancel-disabled>
    <div class="text-center modal-container">
      <div class="content">
        <selfcheck-loader />
        <div class="text">{{ $t('selfcheck.confirming') }}</div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import SelfcheckLoader from '@/components/loader/SelfcheckLoader'

export default {
  components: {
    SelfcheckLoader,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .modal {
    top: 0px;
  }
  .modal-dialog {
    margin: 0 !important;
    height: 100%;
    max-width: 100%;
  }
  .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-body {
    height: 100%;
    padding: 0 !important;
  }
}
.modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #fff;
  padding-top: 20px;
}
.text {
  padding-top: 20px;
}
</style>
